import { UtilsService } from './../../../../services/utils.service';
import { Category } from './../../../generics/data-printer/data-printer.component';
import { Property } from './../../../../models/property.model';
import { Component, Input, OnInit } from '@angular/core';
import { getOwnerName } from 'src/app/models/owner.model';

@Component({
  selector: 'app-property-details-content',
  templateUrl: './property-details-content.component.html',
  styleUrls: ['./property-details-content.component.scss']
})
export class PropertyDetailsContentComponent implements OnInit {

    private propertyContent?: Property;
    @Input()
    set property(pr: Property) {
        this.propertyContent = pr;
        this.updateCategories();
    }
    get property() {
        return this.propertyContent;
    }

    categories: Category[] = [];

    constructor(
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
    }

    updateCategories() {
        if (!this.property) return;
        this.categories = [
            { name: 'Dirección', items: [
                { label: 'Tipo de vía', value: this.property.direccion?.tipoCalle },
                { label: 'Calle', value: this.property.direccion?.calle },
                { label: 'Número', value: this.property.direccion?.numero },
                { label: 'Piso', value: this.property.direccion?.piso },
                { label: 'Departamento', value: this.property.direccion?.departamento },
                { label: 'Código postal', value: this.property.direccion?.codigoPostal },
                { label: 'Provincia', value: this.property.direccion?.localidad?.provincia?.descripcion },
                { label: 'Municipio', value: this.property.direccion?.localidad?.municipio?.descripcion },
                { label: 'Localidad', value: this.property.direccion?.localidad?.descripcion },
            ]}, { name: 'Información de alquiler', items: [
                { label: 'Valor del alquiler', value: this.property.alquiler, type: 'money' },
                { label: 'Valor de las expensas', value: this.property.expensas, type: 'money' },
                { label: 'Tipo de propiedad', value: this.property.tipo, type: 'text' },
                { label: 'Cantidad de ambientes', value: this.property.cantidadAmbientes },
                { label: 'Propietario/s', value: this.property.propietarios.map(prop => `${getOwnerName(prop)} - ${prop.tipoPersona === 'FISICA' ? prop.personaFisica.dni : this.utilsService.parseByType(prop.personaJuridica.cuit, 'cuit')} - ${prop.email}`).join('\n') },
            ]}
        ];
        if (this.property.oficina) {
            this.categories.push({ name: 'Oficina', items: [
                { label: 'Nombre', value: this.property.oficina.nombre },
                { label: 'Nro. sucursal', value: this.property.oficina.sucursal },
                { label: 'Teléfono', value: this.property.oficina.telefonoFijo, type: 'phone' },
                { label: 'CUIT', value: this.property.oficina.cuit, type: 'cuit' },
            ]});
        }
        if (this.property.agente) {
            this.categories.push({ name: 'Agente', items: [
                { label: 'Nombre', value: this.property.agente.nombre },
                { label: 'Apellido', value: this.property.agente.apellido },
                { label: 'Teléfono', value: this.property.agente.celular, type: 'phone' },
                { label: 'CUIT', value: this.property.agente.cuit, type: 'cuit' },
            ]});
        }
    }

}
